import API_BASE_URL from '../Config';

const API_URL = `${API_BASE_URL}/tasas`;

export const getTasas = async (token) => {
    const response = await fetch(API_URL, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar tasas');
    return response.json();
};

export const getTasaById = async (token, id) => {
    const response = await fetch(`${API_URL}/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al obtener tasa');
    return response.json();
};

export const createTasa = async (token, tasa) => {
    const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(tasa)
    });
    if (!response.ok) throw new Error('Error al crear tasa');
    return response.json();
};

export const updateTasa = async (token, id, tasa) => {
    const response = await fetch(`${API_URL}/${id}`, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(tasa)
    });
    if (!response.ok) throw new Error('Error al actualizar tasa');
    return response.json();
};

export const deleteTasa = async (token, id) => {
    const response = await fetch(`${API_URL}/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al eliminar tasa');
    return true;
};
